<template>
  <footer class="footer py-4 d-flex flex-lg-column" id="kt_footer">
    <div class="container-xxl d-flex justify-content-between bd-highlight align-items-center">
      <div class="p-2 bd-highlight">
        <span class="text-muted fw-bold me-1">{{fullYear}}© Polisoft Software Ltd</span> 
      </div>
      <div class="p-2 bd-highlight">
        <Contents/>
      </div>
      <div class="p-2 bd-highlight">        
        <a href="https://polisoft.co.uk" target="_blank" class="text-muted fs-7 fw-semibold text-hover-primary"
          :class="{'ms-10': aggrementContents.length > 0}">
          CreatorCUBE v{{ cubeVersion }} CP
        </a>
      </div>
      <div class="p-2 bd-highlight" v-if="userData.controller_account_name">
        <span class="badge badge-light align-items-right justify-content-end text-muted fs-7 fw-semibold">
          {{userData.controller_account_name }}
        </span> 
      </div>
      
      <div class="flex-grow-1 bd-highlight d-none">
        <!-- Idle for Screen Lock -->
        <Vidle v-if="this.userData.is_locked !== 1 && this.userData.is_lock_screen_active == 1 && userData.lock_screen_time > 0" @idle="onScreenLock" :wait="3" :duration="lockScreenTime" />
      </div>
      <div class="flex-grow-1 bd-highlight d-none">
        <!-- Idle for Logout -->
        <Vidle v-if="this.userData.is_automatic_logout_active == 1 && userData.automatic_logout_time > 0" @idle="forceSignOut" @remind="onremind" :reminders="[10]" :wait="3" :duration="automaticLogoutTime" />
      </div> 
    </div>
  </footer>
</template>
<script>
import axios from "axios";
import Contents from "../Contents.vue";
export default {
  name: "NavFooter",
  components: {
    Contents
  },
  data() {
    return {
      userData: this.$getUser(),
      automaticLogoutTime: this.$getUser().automatic_logout_time ? this.$getUser().automatic_logout_time * 60 : 0,
      lockScreenTime: this.$getUser().lock_screen_time ? this.$getUser().lock_screen_time * 60 : 0,
      fullYear: new Date().getFullYear(),
      aggrementContents: [],
      cubeVersion: null
    };
  },
  methods: {
    onremind() {
      let timerInterval;
      this.$swal.fire({
        title: 'Session expiring soon!',
        html: 'You have been inactive for <span class="fw-bolder">'+ this.userData.automatic_logout_time +'</span> minutes. You will be automatically signed out in <b></b> seconds. If session expires, all of unsaved data will be lost. Click <span class="fw-bolder">Stay Logged In</span> to continue.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Stay Logged In',
        allowOutsideClick: false,
        timer: 10000,
        timerProgressBar: true,
        didOpen: () => {
          const b = this.$swal.getHtmlContainer().querySelector('b');
          b.textContent = 10;
          timerInterval = setInterval(() => {
            b.textContent = (this.$swal.getTimerLeft() / 1000).toFixed(0)
          }, 1000)
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      });
    },	   
    forceSignOut() {      
      this.$parent.isScreenLocked = false;      
      this.$removeUser('user_' + this.$getUser().session_id);
      sessionStorage.clear();
      this.$router.push({ name: 'Logout', params: { m: this.userData.automatic_logout_time } });
    },
    onScreenLock() {
      this.userData.is_locked = 1;
      this.$parent.isScreenLocked = true;
    },
    getAgreementContents() {
      const parameters = {
				country_code: this.$getUser().company_country_code,
        session_id: this.$getUser().session_id
			}
			axios.post('api/Helper/GetContents', parameters, {'Content-Type': 'application/json'})
			.then((response) => { 
				this.aggrementContents = response.data;
			})
			.catch(function (error) {
				console.error(error);
			});
    },
    getVersion() {
      axios.get('/api/Helper/GetVersion').then((response) => {
        this.cubeVersion = response.data;
      })
      .catch(function (error) {
         console.error(error);
      });
    }
  },
  mounted() {
    this.emitter.on("changeScreenLockStatus", item => {
      this.userData.is_locked = item;
    });
  },
  created() {
    this.getAgreementContents();
    this.getVersion();
  }
};
</script>